import { useCallback, useMemo, useSyncExternalStore } from "react";

/**
 * `--breakpoint-tablet` in styles/globals.css: where the app shell switches
 * from phone chrome to tablet chrome.
 */
export const TABLET_SHELL_QUERY = "(min-width: 744px)";

/** Whether `query` matches now, re-rendering when that changes. */
export function useMediaQuery(query: string): boolean {
  const list = useMemo(() => window.matchMedia(query), [query]);
  const subscribe = useCallback(
    (onChange: () => void) => {
      list.addEventListener("change", onChange);
      return () => list.removeEventListener("change", onChange);
    },
    [list]
  );
  return useSyncExternalStore(subscribe, () => list.matches);
}
